// All delays in ms

const SECOND = 1000;

const DELAY = Object.freeze({
  // no delay useful only for adding a new setTimeout frame at the top of the queue
  none: 0,
  // similar to the above, only this is what browsers would usually do even for 0
  instant: 10,

  // the lower and upper bounds for a user to not notice delay
  flash: 100,
  fast: 400,

  // amount of time to keep user's attention
  attention: SECOND,

  // amount of time to hide some less important UI elements
  autohide: 3 * SECOND,

  // after 10 seconds user usually loses interest
  disinterest: 10 * SECOND,
});

// noinspection JSUnusedGlobalSymbols
export default DELAY;
